import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers,
  FaBoxes,
  FaShoppingCart,
  FaStar,
  FaPercent,
} from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';

const ACTIONS = [
  { key: 'manageUsers', path: '/users', icon: FaUsers, tone: 'hover:bg-indigo-50 text-indigo-600' },
  { key: 'manageProducts', path: '/products', icon: FaBoxes, tone: 'hover:bg-purple-50 text-purple-600' },
  { key: 'viewOrders', path: '/orders', icon: FaShoppingCart, tone: 'hover:bg-green-50 text-green-600' },
  { key: 'bestsellers', path: '/bestsellers', icon: FaStar, tone: 'hover:bg-amber-50 text-amber-600' },
  { key: 'discounts', path: '/discounts', icon: FaPercent, tone: 'hover:bg-rose-50 text-rose-600' },
];

const QuickActionsCard = ({ delay = 0 }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="bg-white rounded-xl border border-gray-200 shadow-sm p-6"
    >
      <h2 className="text-base font-semibold text-gray-900 mb-4">
        {t('dashboard.quickActions.title')}
      </h2>
      <div className="grid grid-cols-2 gap-2">
        {ACTIONS.map(({ key, path, icon: Icon, tone }) => (
          <button
            key={key}
            onClick={() => navigate(path)}
            className={`group flex items-center gap-3 p-3 rounded-lg border border-gray-200 ${tone} transition-colors text-left`}
          >
            <Icon className="h-4 w-4" />
            <span className="text-sm font-medium text-gray-800 truncate">
              {t(`dashboard.quickActions.${key}`)}
            </span>
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default QuickActionsCard;
